import React from "react";
import { Icon } from "@iconify/react";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";

function AccessRestriced() {
  const { buttonClass } = useButtonTableStyle();
  return (
    <div id="main-wrapper">
      <div className="position-relative overflow-hidden min-vh-100 w-100 d-flex align-items-center justify-content-center">
        <div className="d-flex align-items-center justify-content-center w-100">
          <div className="row justify-content-center w-100">
            <div className="col-lg-4">
              <div className="text-center">
                <div className="d-inline-block p-4 rounded-circle bg-primary bg-opacity-10 mb-4">
                  <Icon
                    icon="solar:hourglass-bold"
                    className="text-primary"
                    width="48"
                    height="48"
                  />
                </div>
                <h1 className="fw-semibold mb-3 fs-9">
                  Awaiting Admin Approval
                </h1>
                {/* <h4 className="fw-semibold mb-4 text-secondary">
                  Awaiting Admin Approval
                </h4> */}
                <p className="text-muted mb-4">
                  Your account is currently under review and needs approval from
                  an administrator before you can access the software.
                </p>

                {/* Status Bar */}
                <div className="position-relative my-5">
                  <div className="progress" style={{ height: "2px" }}>
                    <div
                      className="progress-bar bg-primary"
                      style={{ width: "50%" }}
                    ></div>
                  </div>

                  <div
                    className="d-flex justify-content-between position-relative"
                    style={{ marginTop: "-20px" }}
                  >
                    <div className="text-center">
                      <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white mb-2"
                        style={{ width: "40px", height: "40px" }}
                      >
                        <Icon
                          icon="solar:user-plus-bold"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div className="text-primary small fw-medium">Signup</div>
                    </div>

                    <div className="text-center">
                      <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white mb-2"
                        style={{ width: "40px", height: "40px" }}
                      >
                        <Icon
                          icon="solar:clock-circle-bold"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div className="text-primary small fw-medium">
                        Awaiting Approval
                      </div>
                    </div>

                    <div className="text-center">
                      <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light text-muted mb-2"
                        style={{ width: "40px", height: "40px" }}
                      >
                        <Icon
                          icon="solar:check-circle-bold"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div className="text-muted small">Access Granted</div>
                    </div>
                  </div>
                </div>

                <p className="text-muted mb-4">
                  Estimated review time: 24–48 hours
                </p>

                <div className="d-flex align-items-center justify-content-center gap-2 text-muted mb-4">
                  <span>Questions? Contact us at </span>
                  <a
                    href="mailto:support@email.com"
                    className="text-primary text-decoration-none fw-medium"
                  >
                    support@email.com
                  </a>
                </div>

                <a className={`btn btn-primary ${buttonClass}`} href="/login" role="button">
                  Back to Login
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccessRestriced;
